import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { DrainableMachine } from '../lib/machine-drain';
import { ConfirmDialog } from './ConfirmDialog';

// The ask before a Machines card's "Stop taking new work" (#6560, the drain). Presenter over
// `createMachineDrain`'s confirm gate (`lib/machine-drain.ts`), which owns the drain:
// `machine === null` keeps the dialog shut.

export function MachineDrainDialog(props: {
  readonly machine: DrainableMachine | null;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}): JSX.Element {
  return (
    <ConfirmDialog
      open={props.machine !== null}
      title={t('fleet.machines.pause_title', { name: props.machine?.display_name ?? '' })}
      desc={t('fleet.machines.pause_body')}
      cancelLabel={t('fleet.machines.pause_cancel')}
      actionLabel={t('fleet.machines.pause_confirm')}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
    />
  );
}
